import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import Footer from '../common/Footer';
import Header from '../common/Header';
import About from '../pages/About';
import BlogDetails from '../pages/BlogDetails';
import Blogs from '../pages/Blogs';
import Career from '../pages/Career';
import Contact from '../pages/Contact';
import LandingPage from '../pages/LandingPage';
import Services from '../pages/Services';
import Work from '../pages/Work';
import WorkDetails from '../pages/WorkDetails';
import ScrollToTop from '../utils/ScrollToTop/ScrollToTop';
const Index = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/work" element={<Work />} />
                <Route path="/blog" element={<Blogs />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/career" element={<Career />} />
                <Route path="/blog-details" element={<BlogDetails />} />
                <Route path="/work-details" element={<WorkDetails />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
};

export default Index;